import { useQuery } from "@tanstack/react-query"
import { Guid } from "../app/models/CustomType"
import { DeviceSoftwarePackageFirmwareConstraintGet } from "../app/models/DeviceSoftwarePackageFirmwareConstraint"
import { digitalManagerApi } from "../services/api"

export function useDeviceSoftwarePackageFirmwareConstraints(deviceId?: Guid) {
  const {
    data: deviceSoftwarePackageFirmwareConstraints = [],
    isLoading: isLoadingDeviceSoftwarePackageFirmwareConstraints,
  } = useQuery({
    queryKey: ["deviceSoftwarePackageFirmwareConstraints", deviceId],
    queryFn: () =>
      digitalManagerApi
        .get<
          DeviceSoftwarePackageFirmwareConstraintGet[]
        >(`/devices/${deviceId}/softwarePackageFirmwareConstraints`)
        .then((r) => r.data),
    enabled: !!deviceId,
  })

  return {
    deviceSoftwarePackageFirmwareConstraints,
    isLoadingDeviceSoftwarePackageFirmwareConstraints,
  }
}
